/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

export const RECEIVED_EXTERNAL_INVESTMENT_ADVICE_CONSENT =
  'RECEIVED_EXTERNAL_INVESTMENT_ADVICE_CONSENT';
export const receivedExternalInvestmentAdviceConsent = (payload) => ({
  type: RECEIVED_EXTERNAL_INVESTMENT_ADVICE_CONSENT,
  adviceConsent: payload
});

export const SHOW_CONSENT_MODAL = 'SHOW_CONSENT_MODAL';
export const showConsentModal = (flag) => ({
  type: SHOW_CONSENT_MODAL,
  showConsentModal: flag
});

export const DELAY_LINK_ACCOUNT = 'DELAY_LINK_ACCOUNT';
export const delayLinkAccount = (flag) => ({
  type: DELAY_LINK_ACCOUNT,
  delayLinkAccount: flag
});

export const SHOW_LINK_MODAL = 'SHOW_LINK_MODAL';
export const showLinkModal = (flag) => ({
  type: SHOW_LINK_MODAL,
  showLinkModal: flag
});

export const RECEIVED_EXTERNAL_INVESTMENT_STATUS =
  'RECEIVED_EXTERNAL_INVESTMENT_STATUS';
export const receivedExternalInvestmentStatus = ({ status }) => ({
  type: RECEIVED_EXTERNAL_INVESTMENT_STATUS,
  status
});

export const UPDATE_EXTERNAL_INVESTMENT_STATUS =
  'UPDATE_EXTERNAL_INVESTMENT_STATUS';
export const updateExternalInvestmentStatus = ({ status }) => ({
  type: UPDATE_EXTERNAL_INVESTMENT_STATUS,
  status
});

export const SET_EXTERNAL_INVESTMENT_CONSENT =
  'SET_EXTERNAL_INVESTMENT_CONSENT';
export const setExternalInvestmentConsent = ({ consent }) => ({
  type: SET_EXTERNAL_INVESTMENT_CONSENT,
  consent
});

export const RECEIVED_EXTERNAL_INVESTMENT_CONSENT =
  'RECEIVED_EXTERNAL_INVESTMENT_CONSENT';
export const receivedExternalInvestmentConsent = ({ consent }) => ({
  type: RECEIVED_EXTERNAL_INVESTMENT_CONSENT,
  consent
});

export const ERROR_EXTERNAL_INVESTMENT_CONSENT =
  'ERROR_EXTERNAL_INVESTMENT_CONSENT';
export const errorExternalInvestmentConsent = (error) => ({
  type: ERROR_EXTERNAL_INVESTMENT_CONSENT,
  error
});

export const ERROR_EXTERNAL_INVESTMENT_STATUS =
  'ERROR_EXTERNAL_INVESTMENT_STATUS';
export const errorExternalInvestmentStatus = (error) => ({
  type: ERROR_EXTERNAL_INVESTMENT_STATUS,
  error
});

export const REQUESTED_EXTERNAL_INVESTMENT_STATUS =
  'REQUESTED_EXTERNAL_INVESTMENT_STATUS';
export const requestedExternalInvestmentStatus = () => ({
  type: REQUESTED_EXTERNAL_INVESTMENT_STATUS
});

export const REQUESTED_SET_EXTERNAL_INVESTMENT_CONSENT =
  'REQUESTED_SET_EXTERNAL_INVESTMENT_CONSENT';
export const requestedSetExternalInvestmentConsent = () => ({
  type: REQUESTED_SET_EXTERNAL_INVESTMENT_CONSENT
});

export const ERROR_SET_EXTERNAL_INVESTMENT_CONSENT =
  'ERROR_SET_EXTERNAL_INVESTMENT_CONSENT';
export const errorSetExternalInvestmentConsent = (error) => ({
  type: ERROR_SET_EXTERNAL_INVESTMENT_CONSENT,
  error
});

export const RECEIVED_SET_EXTERNAL_INVESTMENT_CONSENT =
  'RECEIVED_SET_EXTERNAL_INVESTMENT_CONSENT';
export const receivedSetExternalInvestmentConsent = (consent) => ({
  type: RECEIVED_SET_EXTERNAL_INVESTMENT_CONSENT,
  consent
});
